export const SET_MALL_FORM = 'mall_parking/SET_MALL_FORM';
export const TOGGLE_PARKING_FORM = 'mall_parking/TOGGLE_PARKING_FORM';
